export default "/view/img/49a4ef6ff56971e99c17c4d25373a3ca.png";